import { biometricService } from '@afterpaytouch/portal-api/consumer/biometric'

export const { useDeleteBiometricCredentialsMutation, useGetBiometricCredentialsQuery } = biometricService
